import { Company } from "./company.model"
import { Container } from "./container.model"

export class Poligon {
    id?: number
    name?: string = ""
    points?: string = ""
    companyId?: number
    treshold?:number
    status?:boolean
    simulation?:boolean
    company?:Company
}


export class PoligonDetail {
    id?: number
    poligonId?: number;
    discriminatorId?: number
    discriminator?: string = ""
    poligon?:Poligon
    container?:Container
}